import { gql } from '@apollo/client';

export const CREATE_QUOTE_REQUEST = gql`
  mutation CreateQuoteRequest($input: QuoteRequestInput!) {
    createQuoteRequest(input: $input) {
      id
      reference
      status
      source
    }
  }
`;
